import { useState } from 'react'
import { api } from './api.ts'
import type { SimulationCopyMade } from './simulationCopy.ts'

/**
 * Copying the conferência on screen into a simulation (#586).
 *
 * Kept for the life of the screen: the copy is in another account, so what the
 * screen holds afterwards is the way to it rather than a place to navigate.
 */
export function useCopyToSimulation(verificationId: string) {
  const [copying, setCopying] = useState(false)
  const [made, setMade] = useState<SimulationCopyMade | undefined>()
  const [error, setError] = useState<string | undefined>()

  async function copy() {
    if (copying) return
    setCopying(true)
    setError(undefined)
    try {
      setMade(await api.copyToSimulation(verificationId))
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'falha ao copiar para simulação')
    } finally {
      setCopying(false)
    }
  }

  return { copying, made, error, copy }
}
